import * as React from "react";
import "../sass/pages/home.scss";
import Layout from "../components/layout/layout";
import {Link} from "gatsby";
import {StaticImage} from "gatsby-plugin-image";
import Ampersand from "../components/SVG/ampersand";
import CallToAction from "../components/callToAction/callToAction";
import RoundLogo from "../components/SVG/RoundLogo";
import IllustrationIcon from "../components/SVG/icons/illustrationIcon";
import BrandingIcon from "../components/SVG/icons/brandingIcon";
import LetteringIcon from "../components/SVG/icons/letteringIcon";
import Parallax from "../components/parallax/main";
import IntroSection from "../components/introSection/main";
import SplitLinkContainer from "../components/splitLinkContainer/main";
import ThreeCardContainer from "../components/threeCardContainer/main";
import Card from "../components/Card/main";
import Topper from "../components/topper/topper";
import useScreenSize from "../Hooks/useScreenSize";
import {useEffect, useState} from "react";

const IndexPage = () => {
    const [ratio,setRatio] = useState(0);
    const [isMobile] = useScreenSize(0,1064);
    useEffect(()=>{
        function scrollHandler (){
            setRatio(window.scrollY);
        }
        if(typeof window !== "undefined"){
            window.addEventListener("scroll",scrollHandler)
        }
    },[])

    const rootStyle = isMobile ?  {
        transform:`translate3d(0,0,0)`,
        backgroundPositionY: `${Math.abs(ratio)}px`
    } : {};
    const style = {
        transform: `rotate(${ratio / 500 * 360 * -1}deg)`,
    };
    return (
        <>
            <Topper/>
            <Layout
                id={"home-screen"}
                name={"home"}
                current={"home"}
            >
                <Parallax style={ rootStyle }  className="full">
                    <RoundLogo style={style}/>
                </Parallax>
                <IntroSection/>
                <SplitLinkContainer className={"full"}>
                    <Link to={"/illustration"}>
                    <span className="illustration overlay-text">
                        illustration
                    </span>
                        <StaticImage
                            src={"../images/IllustrationCover.png"}
                            alt={"A design image"}
                            formats={["auto","webp"]}
                        />
                    </Link>
                    <Ampersand/>
                    <Link to={"/design"}>
                    <span className="design overlay-text">
                        design
                    </span>
                        <StaticImage
                            src={"../images/DesignCover.png"}
                            alt={"A design image"}
                            formats={["auto","webp"]}
                        />
                    </Link>
                </SplitLinkContainer>
                <hr className={"primary"}/>
                <ThreeCardContainer>
                    <h2>Do you ...</h2>
                    <div className="card-container">
                        <Card icon={<IllustrationIcon className={"icon illustration"}/>}>
                            Have a character or story you want to breathe life into with dynamic illustration?
                        </Card>
                        <Card className={"accent"} icon={<BrandingIcon className={"icon branding"}/>}>
                            Have a new or evolving brand that needs its story told with unique visuals?
                        </Card>
                        <Card className={"accent-secondary"} icon={<LetteringIcon className={"icon lettering"}/>}>
                            Need expressive, custom lettering to drive home a message with personality?
                        </Card>
                    </div>
                    <p>
                        If this sounds like you,
                        I’m here for it!
                        These are just a few ways that I’ve worked with my clients to bring their visions to life.
                        Get in touch, I’m excited to see what we can create together!
                    </p>
                </ThreeCardContainer>
                <CallToAction/>
            </Layout>
        </>
    )
}

export default IndexPage
